<script>
  import IconLobby from '@/assets/images/svg/icon-lobby.svg';
  import IconFastPlay from '@/assets/images/svg/icon-fastplay.svg';
  import IconDepositAdd from '@/assets/images/svg/icons/deposit-add.svg';
  import IconPvP from '@/assets/images/svg/icons/player-vs-player.svg';
  import IconCAF from '@/assets/images/svg/icons/icon-caf.svg';
  import IconAccount from '@/assets/images/svg/icon-account.svg';

  export default {
    name: 'BottomNav',

    components: {
      IconLobby,
      IconFastPlay,
      IconDepositAdd,
      IconPvP,
      IconCAF,
      IconAccount,
    },

    data: () => ({
      selectedTab: null,
    }),

    computed: {
      tabs: () => [
        {
          title: 'Lobby',
          icon: IconLobby,
          to: '/',
        },
        // {
        //   title: 'FastPlay',
        //   icon: IconFastPlay,
        //   to: '/fastplay',
        // },
        {
          title: 'PvP',
          icon: IconPvP,
          to: '/playervsplayer',
        },
        {
          title: 'Deposit',
          icon: IconDepositAdd,
          to: '/buy-coins',
          isHighlighted: true,
        },
        // {
        //   title: 'PvP',
        //   icon: IconPvP,
        //   to: '/playervsplayer',
        // },
        {
          title: 'Challenge',
          icon: IconCAF,
          to: '/challenge-friends',
        },
        {
          title: 'Account',
          icon: IconAccount,
          to: '/profileuser/yourprofile',
        },
      ],

      path() {
        return this.$route.path;
      },
    },

    watch: {
      path: {
        immediate: true,
        handler(path) {
          const tab = this.tabs.find((tab) => path === tab.to);
          this.selectedTab = tab?.to;
        },
      },
    },

    methods: {
      async redirectTo(path) {
        if (this.$route.path === path) return;

        if (path === '/buy-coins') {
          await this.$store.dispatch('setWalletDialog', {
            value: true,
            tab: 'purchase',
          });
          this.selectedTab = this.$route.path;
        } else {
          await this.$router.push({ path });
        }
      },
    },
  };
</script>

<template>
  <div class="bottom-navbar">
    <v-tabs v-model="selectedTab" background-color="transparent" dark height="60px" icons-and-text>
      <v-tab
        v-for="tab in tabs"
        :key="tab.to"
        v-ripple="false"
        :class="{
          'v-tab--selected': tab.to === selectedTab,
          'v-tab--no-shadow': tab.to === '/',
          'v-tab--highlighted': tab.isHighlighted,
        }"
        :tab-value="tab.to"
        @click="redirectTo(tab.to)"
      >
        <component :is="tab.icon" class="tab-icon" :style="{ height: tab.iconHeight }" />
        <span class="tab-text">
          {{ tab.title }}
        </span>
      </v-tab>
    </v-tabs>
  </div>
</template>

<style lang="scss" scoped>
  .bottom-navbar {
    position: fixed;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 60px;
    text-align: center;
    box-sizing: border-box;
    display: block;
    background: #24073d;
    border-top: 1px solid rgba(255, 255, 255, 0.3);

    z-index: 10;

    @media screen and (min-width: 768px) {
      display: none;
    }

    &::v-deep {
      .v-tabs-slider-wrapper {
        display: none;
      }

      .v-tabs {
        .v-slide-group__content {
          align-items: stretch;

          &.v-tabs-bar__content {
            max-width: 100vw !important;
          }
        }

        .v-slide-group__prev,
        .v-slide-group__next {
          display: none !important;
        }

        .v-slide-group__wrapper {
          overflow: visible;
          contain: unset;
        }

        .v-tab {
          z-index: 2;
          flex-basis: 100%;
          padding: 0;
          flex-direction: column;
          min-width: unset;
          max-width: unset;
          box-shadow: 1px 0 0 0 #350f53 inset;

          .tab-text {
            font-size: 11px;
            font-weight: 500;
            line-height: 12px;
            letter-spacing: 0;
            text-transform: none;
            margin-top: 6px;
            color: #fff;
          }

          .tab-icon {
            height: 18px;
            transform: scale(0.8);
            margin-bottom: 0;
          }

          &--selected {
            .tab-text {
              color: #f8bf1e;
            }

            .tab-icon path {
              fill: #f8bf1e;
            }

            &::before {
              content: none;
            }
          }

          &--no-shadow {
            box-shadow: none;
          }

          &:before {
            content: none;
          }

          &--highlighted {
            position: relative;
            z-index: 3;
            transform: translateY(-8px);

            &:before {
              position: absolute;
              content: '';
              top: auto;
              bottom: -6px;
              left: 0;
              right: auto;
              width: 100%;
              height: 70px;
              opacity: 1;
              border-radius: 10px 10px 0 0;
              background: var(--v-gold-base);
            }

            .tab-icon {
              position: relative;
              width: 24px;
              height: 24px;
            }

            .tab-text {
              position: relative;
              font-size: 14px;
              font-weight: 700;
              margin-top: 6px;
              color: #1c0630;
            }
          }

          @media screen and (min-width: 360px) {
            .tab-icon {
              transform: scale(1);
            }
          }
        }
      }
    }
  }
</style>
